<div class="bmc-user-jobs">
  <h5 class="bz-space--stack-m">{{'USERJOBS.DESCRIPTION' | translate}}</h5>
  <div *ngIf="!areThereUserJobs() && !isLoadingJobs" class="bmc-user-jobs__empty-list">
      <h3>{{'USERJOBS.NO_JOBS_TITLE' | translate}}</h3>
      <h4>{{'USERJOBS.NO_JOBS_SUBTITLE' | translate}}</h4>
  </div>
  <div class="bmc-user-jobs__loading-container" *ngIf="isLoadingJobs">
    <bz-loading [size]="'m'" class="bmc-user-jobs__loading">
      {{ 'GLOBAL.LOADING_DATA' | translate }}</bz-loading>
  </div>
  <bzg-tab-set *ngIf="areThereUserJobs()" class="bmc-user-jobs__container" (onSelectTab)="selectedTab = $event.index">
    <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 0}" displayName="{{'USERJOBS.WAITINGS_JOBS' | translate | uppercase}}">
      <user-jobs-wrapper [userJobs]="waitingUserJobs" (resetEmit)="getAllData()"></user-jobs-wrapper>
    </bzg-tab-item>
    <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 1}" displayName="{{'USERJOBS.EXECUTED_JOBS' | translate | uppercase}}">
      <user-jobs-wrapper [userJobs]="executedUserJobs" (resetEmit)="getAllData()"></user-jobs-wrapper>
    </bzg-tab-item>
  </bzg-tab-set>
</div>
